import { render, staticRenderFns } from "./vehicleequipmentstock.vue?vue&type=template&id=fc382640&scoped=true"
import script from "./vehicleequipmentstock.vue?vue&type=script&lang=js"
export * from "./vehicleequipmentstock.vue?vue&type=script&lang=js"
import style0 from "./vehicleequipmentstock.vue?vue&type=style&index=0&id=fc382640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc382640",
  null
  
)

export default component.exports